import React from "react";
import { Routes, Route } from "react-router-dom";
import SelectedWork from "./SelectedWork";
import About from "./About";
import Portfolio from "./Portfolio";
import ProjectDetails from "./ProjectDetails";
import Services from "./Services";
import Contact from "./Contact";
import Error from "./Error";

const Main = (props) => {
  return (
    <Routes>
      <Route path="/" element={<SelectedWork projects={props.projects} />} />
      <Route path="/about" element={<About />} />
      <Route
        path="/portfolio/"
        element={<Portfolio projects={props.projects} />}
      />
      <Route
        path="/portfolio/project-details/:id"
        element={<ProjectDetails projects={props.projects} />}
      />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/*" element={<Error />} />
    </Routes>
  );
};

export default Main;
